export default {"src":"/_next/static/media/facekbook-icon.407c4681.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};